import { AxiosRequestConfig } from 'axios';
import XLRLogger from 'src/common/helpers/logger';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import { emeraldRequest } from '../../common/api/emerald-request';
import { LocalStorage } from '../../common/helpers/local-storage';
import { IReceipt } from '../../common/interfaces/dtos/IReceipt';
import { EmeraldRequestParams } from '../../common/interfaces/requests/EmeraldRequestParams';
import { store } from '../../common/redux/configure-store';
import { EndOfDayActions } from '../../common/redux/reducers/end-of-day-reducer';
import { printReceipts } from '../../devices/printer-operations';
import { notifyShiftEnd } from '../../login/business-logic/shift-end';
import { notifyShiftStart } from '../../login/business-logic/shift-start';
import { ExecutionTiming } from './end-of-day-status';

export const endOfDayExecute = async (executionTiming: ExecutionTiming): Promise<void> => {
  const axiosConfig: AxiosRequestConfig = {
    url: '/end-of-day/execute',
    method: 'POST',
    data: { executionTiming },
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  await emeraldRequest<IReceipt[]>(emeraldRequestParams)
    .then(
      async (receipt: IReceipt[]): Promise<void> => {
        await printReceipts(receipt).catch(popupMessage);
        notifyCashierShiftChanged(executionTiming);
        store.dispatch(EndOfDayActions.resetActivity());
      },
    )
    .catch((err): void => {
      XLRLogger.error({
        message: 'EOD error',
        source: 'end-of-day-execute.ts',
        data: err,
      });
    });
};
export const notifyCashierShiftChanged = async (
  executionTiming: ExecutionTiming,
): Promise<void> => {
  const lockedUser = LocalStorage.getLockUser();
  if (
    executionTiming === ExecutionTiming.Immediate &&
    !lockedUser &&
    store.getState().user.isAuthenticated
  ) {
    await notifyShiftEnd();
    await notifyShiftStart('AfterEndOfDay');
  }
};
